/* nombre dispositivo grupo subgrupo latitud longitud */
import React, { useState, useEffect, useContext } from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import { MdClose } from "react-icons/md";
import Typography from '@material-ui/core/Typography';
import WidgetContext from "../../context/widget/widgetContext";
import DispositivoContext from "../../context/dispositivo/dispositivoContext";
import MapaWidget from "./Mapa-Widget"
import MenuItem from "@material-ui/core/MenuItem";
import { Grid } from "@material-ui/core";
import { grey } from '@material-ui/core/colors';
import Dialogs from "../Dialog/Dialogs"
import Titulo2 from "../Dialog/Titulo2"
import Informacion from "../Dialog/Informacion"
import IsMobileContext from "../../context/isMobile/isMobileContext";


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////// estilos //////////////////////////////////////////////////////////////////////////
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },


});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <MdClose />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },

}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default function InfoBody({ dispositivo }) {
    const [open, setOpen] = React.useState(true);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const isMobile = useContext(IsMobileContext);
    const { isMobileUse } = isMobile;
    const widgetContext = useContext(WidgetContext);
    const { widgets } = widgetContext;

    let elegido;
    const [center, setCenter] = useState("")
    const [centroZoom, setZoom] = useState(13)
    const [tamaño, setTamaño] = useState()
    const selectCenter = () => {
        setCenter({ lat: elegido.variables[0].dispositivo?.latitud, lng: elegido.variables[0].dispositivo?.longitud });
        setZoom(13);
    }
    const cambiarTamaño = (x) => {
        if (x < 400 && x > 321) {
            return setTamaño("250px")
        } else if (x < 322) {
            return setTamaño("200px")
        }
        else if (x > 400) {
            return setTamaño("300px")
        }
    }
    useEffect(() => {
        cambiarTamaño(window.innerWidth)
        if (elegido) {
            if (elegido.variables[0].dispositivo?.latitud) {
                selectCenter()
            }
        }
    }, []);


    return (
        <div>
            {
                dispositivo ? (
                    (open === true) ?
                        isMobileUse() ?
                            <div>
                                <Grid container direction="row" justify="flex-start" alignItems="flex-start" style={{ width: "99%" }}>
                                    <Grid items xs={8} >
                                        {dispositivo?.latitud ?
                                            <div style={{ width: tamaño, height: "300px" }}>
                                                <MapaWidget
                                                    open={open}
                                                    zoom={centroZoom}
                                                    selected={{ lat: dispositivo?.latitud, lng: dispositivo?.longitud }}
                                                    center={center}
                                                />
                                            </div>
                                            :
                                            (dispositivo?.modelo === "GPS") ?
                                                <div style={{ width: "350px", height: "300px" }}>
                                                    {dispositivo?.latitud ?
                                                        <MapaWidget
                                                            open={open}
                                                            zoom={centroZoom}
                                                            selected={{ lat: dispositivo?.latitud, lng: dispositivo?.longitud }}
                                                            center={center}
                                                        />
                                                        : null}
                                                </div>
                                                :
                                                null
                                        }
                                    </Grid>
                                </Grid>
                            </div>
                            :
                            <div>
                                <Grid container direction="row" justify="flex-start" alignItems="flex-start" style={{ width: "99%" }}>
                                    <Grid items xs={8} >
                                        {dispositivo?.latitud ?
                                            <div style={{ width: "350px", height: "300px" }}>
                                                <MapaWidget
                                                    open={open}
                                                    zoom={centroZoom}
                                                    selected={{ lat: dispositivo?.latitud, lng: dispositivo?.longitud }}
                                                    center={center}
                                                />
                                            </div>
                                            :
                                            (dispositivo?.modelo === "GPS") ?
                                                <div style={{ width: "350px", height: "300px" }}>
                                                    {
                                                        dispositivo?.latitud ?
                                                            <MapaWidget
                                                                open={open}
                                                                zoom={centroZoom}
                                                                selected={{ lat: dispositivo?.latitud, lng: dispositivo?.longitud }}
                                                                center={center}
                                                            />
                                                            :
                                                            null
                                                    }
                                                </div>
                                                :
                                                null
                                        }
                                    </Grid>

                                    <Grid items xs={4} >
                                        <Grid container direction="column" justify="space-between" alignItems="justify">                                            
                                            <Titulo2 titulo={"Dispositivo"} />                                            
                                            <Informacion informacion={dispositivo?.nombre} />
                                            
                                            <Titulo2 titulo={"DevEUI"} />                                            
                                            <Informacion informacion={dispositivo?.numeroSerie} />
                                            
                                            <Titulo2 titulo={"Grupo"} />                                            
                                            <Informacion informacion={dispositivo?.subgrupo.grupo.nombre} />
                                            
                                            <Titulo2 titulo={"Subgrupo"} />                                            
                                            <Informacion informacion={dispositivo?.subgrupo.nombre} />
                                            
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </div>
                        :
                        null
                )
                    : null
            }
        </div>

    );
}